import styled from 'styled-components'

const MyDiv = styled.div`
.badgeId{
  background: #f5f5f5;
  font-size: 9px;
  color: #555;
  border-radius: 16px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.badgeDegi{
  background: #e6f0ff;
  font-size: 10px;
  color: #007AFF;
  border-radius: 8px;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}
  .info_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 20px;
  column-gap: 35px;
}
.btn{
margin-left: 250px; 
}
`
export default MyDiv